import React, { useState, useEffect } from 'react';
import { adminGetGallery, adminCreateGallery, adminUpdateGallery, adminDeleteGallery } from '../../api/client';
import { Plus, Trash2, Save, Loader2, Edit3, X } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

const inp = { background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.1)', color: '#f2f2ff', fontFamily: "'DM Sans', sans-serif", fontSize: 14, borderRadius: 3 };
const lbl = { fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: 2, color: '#6a6a88', display: 'block', marginBottom: 6 };
const CATS = ['Hardware', 'Networking', 'Software', 'Lainnya'];
const empty = { title: '', image_url: '', category: 'Hardware', sort_order: 0 };

export default function GalleryManager() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = async () => { setLoading(true); try { setPhotos(await adminGetGallery()); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  const open = (p) => { setForm(p || {...empty, sort_order: photos.length+1}); setEditing(p?.id||null); setShowForm(true); };
  const close = () => { setShowForm(false); setEditing(null); setForm(empty); };

  const save = async () => {
    if (!form.image_url) { toast.error('URL gambar wajib diisi.'); return; }
    setSaving(true);
    try {
      const data = {...form, sort_order: Number(form.sort_order)};
      if (editing) { await adminUpdateGallery(editing, data); toast.success('Diperbarui!'); }
      else { await adminCreateGallery(data); toast.success('Foto ditambahkan!'); }
      close(); load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm('Hapus foto ini?')) return;
    try { await adminDeleteGallery(id); load(); toast.success('Dihapus.'); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
        <div>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: '#6a6a88', letterSpacing: 2, marginBottom: 4 }}>MANAJEMEN</div>
          <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 22, color: '#f2f2ff', margin: 0 }}>Galeri Foto</h1>
        </div>
        <button onClick={() => open(null)} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px', borderRadius: 3, background: 'linear-gradient(135deg,#00e5ff,#9b00ff)', color: '#07070f', fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 11, border: 'none', cursor: 'pointer', letterSpacing: 1 }}>
          <Plus size={14} /> TAMBAH FOTO
        </button>
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ background: 'var(--card)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 4, padding: 32, width: '100%', maxWidth: 480 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
              <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 18, color: '#f2f2ff', margin: 0 }}>{editing ? 'Edit' : 'Tambah'} Foto</h2>
              <button onClick={close} style={{ background: 'none', border: 'none', color: '#6a6a88', cursor: 'pointer' }}><X size={18} /></button>
            </div>
            {form.image_url && <img src={form.image_url} alt='' style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 3, marginBottom: 16, filter: 'brightness(0.8)' }} onError={e => e.target.style.display='none'} />}
            <div style={{ display: 'grid', gap: 14, marginBottom: 20 }}>
              <div><Label style={lbl}>URL GAMBAR *</Label><Input value={form.image_url} onChange={e => setForm(p=>({...p,image_url:e.target.value}))} placeholder='https://...' style={inp} /></div>
              <div><Label style={lbl}>JUDUL / KETERANGAN</Label><Input value={form.title} onChange={e => setForm(p=>({...p,title:e.target.value}))} placeholder='Pemasangan jaringan kantor...' style={inp} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <Label style={lbl}>KATEGORI</Label>
                  <select value={form.category} onChange={e => setForm(p=>({...p,category:e.target.value}))} style={{...inp, width:'100%', padding:'10px 12px', cursor:'pointer'}}>
                    {CATS.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div><Label style={lbl}>URUTAN</Label><Input type='number' value={form.sort_order} onChange={e => setForm(p=>({...p,sort_order:e.target.value}))} style={inp} /></div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={save} disabled={saving} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '11px', borderRadius: 3, background: 'linear-gradient(135deg,#00e5ff,#9b00ff)', color: '#07070f', fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 11, border: 'none', cursor: saving?'not-allowed':'pointer', letterSpacing: 1, opacity: saving?0.7:1 }}>
                {saving ? <Loader2 size={14} style={{animation:'spin 1s linear infinite'}} /> : <Save size={14} />} SIMPAN
              </button>
              <button onClick={close} style={{ padding: '11px 20px', borderRadius: 3, background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', color: '#6a6a88', cursor: 'pointer', fontFamily: "'DM Mono', monospace", fontSize: 11 }}>BATAL</button>
            </div>
          </div>
        </div>
      )}

      {loading ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: '#6a6a88', gap: 10, fontFamily: "'DM Mono', monospace", fontSize: 13 }}><Loader2 size={18} style={{animation:'spin 1s linear infinite'}} />MEMUAT...</div> : (
        <div>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88', marginBottom: 16 }}>{photos.length} FOTO TERDAFTAR</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12 }}>
            {photos.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 60, color: '#6a6a88', fontFamily: "'DM Mono', monospace", fontSize: 12, border: '1px dashed rgba(255,255,255,0.08)', borderRadius: 4 }}>BELUM ADA FOTO. TAMBAHKAN DOKUMENTASI PEKERJAAN ANDA!</div>}
            {photos.map(p => (
              <div key={p.id} style={{ position: 'relative', borderRadius: 4, overflow: 'hidden', background: 'var(--card)', border: '1px solid rgba(255,255,255,0.07)', aspectRatio: '4/3', transition: 'border-color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(0,229,255,0.2)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'}>
                <img src={p.image_url} alt={p.title||''} style={{ width:'100%', height:'100%', objectFit:'cover', filter:'brightness(0.7)' }} />
                <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(7,7,15,0.9) 0%, transparent 50%)', padding:10, display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
                  {p.title && <div style={{ fontFamily:"'DM Sans', sans-serif", fontSize:11, color:'#f2f2ff', fontWeight:600, marginBottom:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.title}</div>}
                  <div style={{ fontFamily:"'DM Mono', monospace", fontSize:9, color:'#00e5ff', letterSpacing:0.5, marginBottom:8 }}>{p.category?.toUpperCase()}</div>
                  <div style={{ display:'flex', gap:5 }}>
                    <button onClick={() => open(p)} style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:4, padding:'5px', borderRadius:2, background:'rgba(0,229,255,0.15)', border:'none', color:'#00e5ff', cursor:'pointer', fontSize:10, fontFamily:"'DM Mono', monospace" }}><Edit3 size={10} /></button>
                    <button onClick={() => del(p.id)} style={{ padding:'5px 8px', borderRadius:2, background:'rgba(239,68,68,0.15)', border:'none', color:'#ef4444', cursor:'pointer' }}><Trash2 size={10} /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
